// src/pages/Login.js
import React, { useEffect, useRef, useState } from "react";
import {
  signInWithEmailAndPassword,
  signInWithPopup,
  signInWithRedirect,
  getRedirectResult,
} from "firebase/auth";
import { auth, provider } from "../firebase";
import { useNavigate } from "react-router-dom";
import { FcGoogle } from "react-icons/fc";
import Lottie from "lottie-react";
import loginAnimation from "../assets/Login.json";
import "../styles/Login.css";

export default function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loadingGoogle, setLoadingGoogle] = useState(false);
  const signingRef = useRef(false); // prevents concurrent popups

  // If we returned from a redirect, complete it silently
  useEffect(() => {
    getRedirectResult(auth).catch(() => {});
  }, []);

  const handleGoogleLogin = async () => {
    if (signingRef.current) return; // ignore double-clicks
    signingRef.current = true;
    setLoadingGoogle(true);
    setError("");

    try {
      await signInWithPopup(auth, provider);
      navigate("/");
    } catch (err) {
      // If popup was blocked or closed, use redirect (reliable on Safari/iOS)
      if (
        err?.code === "auth/popup-blocked" ||
        err?.code === "auth/popup-closed-by-user" ||
        err?.code === "auth/cancelled-popup-request"
      ) {
        try {
          await signInWithRedirect(auth, provider);
          return; // navigation will happen after redirect completes
        } catch (e) {
          setError(e.message);
        }
      } else {
        setError(err.message);
      }
    } finally {
      signingRef.current = false;
      setLoadingGoogle(false);
    }
  };

  const handleEmailLogin = async () => {
    try {
      setError("");
      await signInWithEmailAndPassword(auth, email, password);
      navigate("/");
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="login-wrapper">
      <div className="login-container">
        {/* Left Panel */}
        <div className="login-left">
          <h2>Welcome Back to Parivar Wedding Event 🎉</h2>
          <p>Your event journey continues. Log in and let’s create magic again!</p>
          <Lottie animationData={loginAnimation} loop className="lottie" />
        </div>

        {/* Right Panel */}
        <div className="login-right">
          <h3>Login to Your Account</h3>

          <input
            type="email"
            placeholder="Email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          {error && <div className="error">{error}</div>}

          <button type="button" className="submit-btn" onClick={handleEmailLogin}>
            Login with Email
          </button>

          <div className="login-divider">or</div>

          <button
            type="button"
            className="google-btn"
            onClick={handleGoogleLogin}
            disabled={loadingGoogle}
            style={{ opacity: loadingGoogle ? 0.7 : 1, pointerEvents: loadingGoogle ? "none" : "auto" }}
          >
            <FcGoogle size={22} />
            <span>{loadingGoogle ? "Opening Google…" : "Continue with Google"}</span>
          </button>

          <p className="footer-text">
            Don’t have an account? <a href="/register">Register here</a>
          </p>
        </div>
      </div>
    </div>
  );
}
